'use client';

import React, {FC} from 'react';
import Image from 'next/image';

import styles from './styles.module.scss';

const Tutorial: FC = () => {
  return (
    <section className={styles['section-tutorial']}>
      <div className="default-container">
        <div data-testid="tutorial-section" className={styles.tutorial}>
          <h3>
            Connect With <br />
            <b>Fiduciary Financial Advisors</b>
          </h3>
          <div className={styles['tutorial__step-item']}>
            <div className={styles.tutorial__item}>
              <figure className={styles.tutorial__item_icon}>
                <Image
                  src="/static/img/homepage/puzzle-piece_1f9e9 1.png"
                  alt="Find an Advisor"
                  width="30"
                  height="30"
                />
              </figure>
              <div className={styles.tutorial__item_text}>
                <span
                  className={`only-mobile ${styles.tutorial__item_text_steps}`}>
                  STEP 1
                </span>
                <h4>Find</h4>
                <p className={styles.tutorial__item_text_steps_info}>
                  Complete our short quiz and connect with your advisor.
                </p>
              </div>
            </div>
            <Image
              src="/static/svg/arrow-right-bold.svg"
              alt="Next Step"
              className={styles['only-desktop-noTablet']}
              width="26"
              height={22}
              unoptimized
            />
            <div className={styles.tutorial__item}>
              <figure className={styles.tutorial__item_icon}>
                <Image
                  src="/static/img/homepage/mobile-phone_1f4f1-3 1.png"
                  alt="Interview an Advisor"
                  width="30"
                  height="30"
                />
              </figure>
              <div className={styles.tutorial__item_text}>
                <span
                  className={`only-mobile ${styles.tutorial__item_text_steps}`}>
                  STEP 2
                </span>
                <h4>Interview</h4>
                <p className={styles.tutorial__item_text_steps_info}>
                  Meet with the advisors you are interested in.
                </p>
              </div>
            </div>
            <Image
              src="/static/svg/arrow-right-bold.svg"
              alt="Next Step"
              className={styles['only-desktop-noTablet']}
              width="26"
              height={22}
              unoptimized
            />
            <div className={styles.tutorial__item}>
              <figure className={styles.tutorial__item_icon}>
                <Image
                  src="/static/img/homepage/handshake_1f91d 1.png"
                  alt="Hire your Advisor!"
                  width="30"
                  height="30"
                />
              </figure>
              <div className={styles.tutorial__item_text}>
                <span
                  className={`only-mobile ${styles.tutorial__item_text_steps}`}>
                  STEP 3
                </span>
                <h4>Hire your advisor!</h4>
                <p className={styles.tutorial__item_text_steps_info}>
                  Decide which advisor is the best fit and get started.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Tutorial;
